<style scoped>
.two-part {
  width: 50%;
  padding: 10px;
}
.form-group:not([class*=' col-']) {
  width: 100%;
  width: 33.333333%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
}
</style>

<template>
  <div>
    <div class="d-flex justify-content-between" style="margin-bottom: 10px">
      <div>
        <p style="font-size: 12px">
          <b-icon icon="info" variant="success"></b-icon>&nbsp;Select table row
          for more option.
        </p>
      </div>
      <b-button-group v-if="editableOps">
        <b-button
          variant="outline-primary"
          size="sm"
          @click="refreshGrid"
          >Refresh</b-button
        >
      </b-button-group>
    </div>
    <DxDataGrid
      id="cement-pump-grid"
      ref="cementPumpGrid"
      :data-source="cementPumpDataSource"
      :show-borders="false"
      :show-column-lines="false"
      :show-row-lines="true"
      column-resize-mode="nextColumn"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :cell-hint-enabled="true"
      :word-wrap-enabled="true"
      :column-auto-width="false"
      :column-width="100"
      :height="300"
      @row-inserted="savedRows"
      @row-updated="updatedRows"
      @row-removed="removedRows"
    >
      <DxPaging :enabled="false"/>
      <DxSelection mode="single"/>
      <DxScrolling column-rendering-mode="virtual"/>
      <DxEditing
          :allow-updating="true"
          :allow-adding="true"
          :allow-deleting="true"
          :use-icons="true"
          mode="row"/>
      <DxColumn v-for="column in tableFields" :key="column.key" :data-field="column.key" :caption="column.label" :data-type="column.type" />
    </DxDataGrid>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxEditing,
  DxFormItem,
  DxLookup,
  DxSelection,
  DxScrolling
} from 'devextreme-vue/data-grid'
import notify from "devextreme/ui/notify"
import { formMethods } from '@state/helpers'
import CustomStore from 'devextreme/data/custom_store'
import mapApiUrl from '@/src/utils/api-mapper'
import axios from 'axios'
import qs from 'querystring'

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxEditing,
    DxSelection,
    DxScrolling,
    // DxFormItem,
    DxLookup,
    // DxForm,
    // DxSimpleItem,
    // DxGroupItem,
  },
  props: {
    stageNo: {
      type: Number,
      default: undefined,
    },
    editableOps: {
      type: Boolean,
      default: false,
    },
    wellId: {
      type: Number,
      default: undefined,
    },
  },

  data() {
    return {
      cementPumpDataSource: null,
      selectedRow: [],
      listItem: [],
      perPage: 10,
      tableBusy: false,
      currentPage: 1,
      tableFields: [
        { key: 'fluidPumped', label: 'Fluid Pumped', type: 'string' },
        { key: 'pumpingRate', label: 'Pumping Rate', type: 'number' },
        { key: 'volume', label: 'Volume', type: 'number' },
        { key: 'pumpingStartDateTime', label: 'Pumping Start Date Time', type: 'date' },
        { key: 'pumpingEndDateTime', label: 'Pumping End Date Time', type: 'date' },
        { key: 'operation', label: 'Operation', type: 'string' }, 
        { key: 'placementMethod', label: 'Placement Method', type: 'string' },
        { key: 'slurryTopMd', label: 'Slurry Top MD', type: 'number' },
        { key: 'slurryBaseMd', label: 'Slurry Base MD', type: 'number' },
        { key: 'shutDownTime', label: 'Shut Down Time', type: 'number' },
        { key: 'topOfFluid', label: 'Top of Fluid', type: 'number' },
        { key: 'topOfFluidTvd', label: 'Top of Fluid TVD', type: 'number' },
        { key: 'strokes', label: 'Strokes', type: 'number' },
        { key: 'strokeRate', label: 'Stroke Rate', type: 'number' },
        { key: 'bulkCement', label: 'Bulk Cement', type: 'number' },
        { key: 'dateStartMixing', label: 'Date Start Mixing', type: 'date' },
        { key: 'mixingRate', label: 'Mixing Rate', type: 'number' },
        { key: 'dateStartSlurry', label: 'Date Start Slurry', type: 'date' },
        { key: 'dateStartDisplace', label: 'Date Start Displace', type: 'date' },
        { key: 'dateEndPumping', label: 'Date End Pumping', type: 'date' },
        { key: 'dispRateMax', label: 'Disp Rate Max', type: 'number' },
        { key: 'dispRateFinal', label: 'Disp Rate Final', type: 'number' },
        { key: 'dispRateAvg', label: 'Disp Rate Avg', type: 'number' },
        { key: 'dispPressureFinal', label: 'Disp Pressure Final', type: 'number' },
        { key: 'surfaceMixTemp', label: 'Surface Mix Temp', type: 'number' },
        { key: 'bhStaticTemp', label: 'BH Static Temp', type: 'number' },
        { key: 'bhCircTemp', label: 'BH Circ Temp', type: 'number' },
        { key: 'flowlineTemp', label: 'Flowline Temp', type: 'number' },
        { key: 'volBackWas', label: 'Vol Back Was', type: 'number' },
        { key: 'overflushVol', label: 'Overflush Vol', type: 'number' },
        { key: 'preflushVol', label: 'Preflush Vol', type: 'number' },

      ],
      selectedAction: '',
      form: [],
      show: false,
      cementPumpIsLoading: false,
    }
  },

  computed: {
    totalRows: function () {
      return this.listItem.length
    },
  },

  watch: {
    stageNo: function (val) {
      this.refreshGrid()
    },
  },

  created: function () {
    this.init()
  },

  methods: {
    ...formMethods,
    init() {
      this.cementPumpDataSource = new CustomStore({
        key: 'intId',
        load: () => {
          const url = mapApiUrl('/api/form/activity/cement/pumpsch/review')
          const params = {submitId: this.submitId, status: 1}
          return axios.get(url, {params: params}).then(response => response.data.data)
        },
        onLoaded: (result) => {
            // Result is the array of data received from your backend
            console.log("Store received this data:", result);
            
            // Check if the first item actually contains your key
            if (result && result.length > 0) {
                console.log("Sample item structure:", result[0])
            }
        },
        insert: (values) => {
          values.submitId = this.submitId
          const url = mapApiUrl('/api/form/activity/cement/pumpsch/add')
          return axios.post(url, qs.stringify(values)).then(response => response) 
        },
        update: (key, values) => {
          values.submitId = this.submitId
          values.intId = key
          const url = mapApiUrl('/api/form/activity/cement/pumpsch/add')
          return axios.post(url, qs.stringify(values)).then(response => response) 
        },
        remove: (key) => {
          const url = mapApiUrl('/api/form/activity/cement/pumpsch/remove')
          return axios.delete(url, {params: {intId: key}})
        },
      })
    },
    refreshGrid() {
      this.$refs.cementPumpGrid.instance.refresh()
    },
    savedRows(e) { // e.data value is whatever customstore object returns
      notify({ message: `Pumping schedule data has been recorded.`, width: 500 }, 'success', 3000)
    },
    updatedRows(e) { // e.data value is whatever customstore object returns
      notify({ message: `Pumping schedule data has been updated.`, width: 500 }, 'success', 3000)
    },
    removedRows(e) { // e.data value is whatever customstore object returns
      notify({ message: `Pumping schedule data has been removed.`, width: 500 }, 'success', 3000)
    },
    refreshTableAndCombo() {
      this.listItem = []
      if (this.stageNo) {
        this.tableBusy = true
        this.getActivityCementPumpSch({
          params: { stageNo: this.stageNo },
        }).then((resp) => {
          this.listItem = resp.data.data
          this.tableBusy = false
        })
      } else {
        console.log('No stage selected')
      }
      this.loadAllCombo()
    },
    loadAllCombo() {},
    onRowSelected(item) {
      if (item.length === 0) {
        this.selectedRow = []
        this.$refs.tableDataCementPumpSch.clearSelected()
        return
      }
      this.selectedRow = item
      this.form = item[0]
    },
    makeToast(msg) {
      this.$bvToast.toast(msg, {
        title: 'Notification',
        autoHideDelay: 5000,
        appendToast: false,
      })
    },
    saving(e) {
      let rowData = {}
      if (Array.isArray(e.changes)) {
        rowData = {...e.changes[0].data}        
      } else {
        rowData = {...e.changes.data}
      }
      delete rowData.intId
      rowData.submitId = this.submitId
      this.addActivityCementPumpSch({ params: rowData }).then((resp) => {
          this.retrieveDataTable()
          notify({ message: 'Data has been recorded.', width: 300 }, 'success', 5000)
      })
    },
    askServerToRemoveData() {
      if (this.selectedRow.length > 0) {
        const data = { ...this.selectedRow[0] }
        this.removeActivityCementPumpSch({ params: data }).then((resp) => {
          this.refreshTableAndCombo()
          this.closeModalRemove()
          this.makeToast('Remove data cement pumping details success.')
        })
      }
    },
  },
}
</script>